import React, { useEffect, useState } from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
};

export interface SelectProps {
  options: Option[];
  defaultValue?: Option | null;
  className?: string;
  styles?: any;
  onChange?: (selected: Option | null) => void;
  isDisabled?: boolean;
}

const CommonSelect: React.FC<SelectProps> = ({
  options,
  defaultValue,
  className,
  styles,
  onChange,
  isDisabled = false,
}) => {
  const [selectedOption, setSelectedOption] = useState<Option | null>(defaultValue || null);

  useEffect(() => {
    setSelectedOption(defaultValue || null);
  }, [defaultValue]);

  const handleChange = (option: Option | null) => {
    setSelectedOption(option);
    if (onChange) {
      onChange(option);
    }
  };

  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      styles={styles}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      isDisabled={isDisabled}
      placeholder="Select"
      isClearable
    />
  );
};

export default CommonSelect;